import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

const reportDataProblemButton = css`
  display: flex;
  align-items: center;
  line-height: 23px;
  padding: 0;

  > svg {
    margin-right: 10px;
    height: 14px;
    width: 14px;
  }

  :hover {
    background-color: ${colors.white};
  }
`;

export default {
  reportDataProblemButton,
};
